const localStorageAvailable = () => {
  const test = 'test local storage';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test)
  } catch (e) {
    return false
  }
}

const setupLocalStorage = (store) => {
  const previous = localStorage.getItem('app')

  if (previous) {
    store.replaceState(JSON.parse(previous))
  }
}

const VuexLocalStorage = (store) => {
  if (!localStorageAvailable()) {
    return false;
  }
  setupLocalStorage(store);
}

export default VuexLocalStorage;